// extracted by css-extract-rspack-plugin
export default {"menu":"menu-UbPTdQ","item":"item-k6NQXC","active":"active-Ky9gjM","group-label":"group-label-vIKzWy","groupLabel":"group-label-vIKzWy","children":"children-hCUQB_"};